import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Card } from "../../../../models/loyalty-card.model";
import { KontableComponent } from "../../../../modules/UIKit/components/kontable/kontable.component";
import { LoyaltyCardService } from "../../../../services/loyalty/loyalty-card.service";
import { CustomerCardSearchModelFilter, CustomerCardSearchModelFilterTypes } from "./customer-card-search.model";

@Component({
  selector: 'kv-customer-card-search',
  template: `
    <div class="ui-g-12">
      <button *ngIf="showBack" pButton type="button" class="k-generic-btn" icon="fa fa-chevron-left"
              iconPos="left" label="{{ 'common.back' | translate }}"
              (click)="_onBack()"
      ></button>
      <form [formGroup]="searchForm" (submit)="onSearch()">
        <div class="k-row ui-g-12">
          <div [kv-form-element]="{ label: 'common.surname', md: '4'}">
            <input pInputText formControlName="surname" />
          </div>
          <div [kv-form-element]="{ label: 'common.name', md: '4'}">
            <input pInputText formControlName="name" />
          </div>
          <div [kv-form-element]="{ label: 'customers.card_no', md: '4'}">
            <input pInputText formControlName="card_no" />
          </div>
        </div>
        <div class="ui-g-12">
          <div class="ui-g-4"></div>
          <div class="ui-g-4">
            <button pButton type="submit" class="buttonExpand k-generic-btn" icon="fa fa-search" iconPos="left" [label]="'common.apply' | translate" ></button>
          </div>
          <div class="ui-g-4"></div>
        </div>
      </form>
      <div class="ui-g-12" *ngIf="searchPress">

        <app-kontable #tablePT *ngIf="customerItems && searchPress"
                      title = "{{ 'customers.customers_card_search' | translate }}"
                      [columns] = "[
                           'card_no',
                           'divisionSalesNetwork',
                           'channelCode',
                           'storeDescription',
                           'customerDescription',
                           'birth_date',
                           'flg_blk_lst',
                           'customerState'
                        ]"
                      [titles] = "[
                          'customers.card_no',
                           'loyalty.divisionSalesNetwork',
                           'loyalty.channelCode',
                           'loyalty.storeDescription',
                           'loyalty.customerDescription',
                           'common.name',
                           'common.birth_date',
                           'loyalty.blacklist',
                           'common.status'
                        ]"
                      [showDetailsButton]="false"
                      [showInfoButton]="false"
                      [showEditButton]="false"
                      [showGlobalFilter]="false"
                      [showDeleteButton]="false"
                      [showRecoverButton]="false"
                      [source]="customerItems"
                      [paginationType]="paginationType"
                      [additionalRowCommands]="customActions">
          <ng-template #customActions let-row>

            <p-button pTooltip="{{ 'common.select' | translate }}" icon="fa fas fa-arrow-circle-right"  styleClass="ui-button-info" (onClick)="_onCardSelect(row)"></p-button>
          </ng-template>
        </app-kontable>

      </div>
    </div>
  `
})
export class CustomerCardSearchComponent {


  @Output() onCardSelect: EventEmitter<Card> = new EventEmitter();
  @Output() onBack: EventEmitter<any> = new EventEmitter();
  @Input() showBack = true;
  //l'input filter si usa per filtrare la ricerca sulla base di alcune condizioni di filtro estrapolate da un'altra carta data in input
  @Input() filter: CustomerCardSearchModelFilter = {
    filterCard: null,
    type: CustomerCardSearchModelFilterTypes.None
  }

  paginationType = KontableComponent.ClientPagination;
  customerItems: Card[];
  searchPress = false;
  searchForm: FormGroup;



  constructor(
    private fb: FormBuilder,
    private svcCard: LoyaltyCardService
  ){
    this.searchForm = this.fb.group({
      surname: new FormControl(null),
      name: new FormControl(null),
      card_no: new FormControl(null)
    })
  }

  onSearch() {
    let params = Array<{ key: string, value: string }>();

    if (this.searchForm.value.card_no != null) params.push({
      key:'cardNo',
      value: this.searchForm.value.card_no
    });

    if (this.searchForm.value.surname != null && this.searchForm.value.surname != '') params.push({
      key:'customerDescription',
      value: this.searchForm.value.surname
    });



    if (this.searchForm.value.name != null && this.searchForm.value.name != '') {
      let p = params.findIndex(p => p.key == 'customerDescription');
      if (p != -1) {
        const desc = params[p].value
        params.splice(p, 1)
        params.push({
          key:'customerDescription',
          value: desc + ' ' + this.searchForm.value.name
        })
      }
      else
        params.push({
          key:'customerDescription',
          value: this.searchForm.value.name
        });
    }

    if (this.filter.type != CustomerCardSearchModelFilterTypes.None) {
      switch (this.filter.type) {
        case CustomerCardSearchModelFilterTypes.LoyaltyChannel:
          params.push({
            key: 'channelCode',
            value: this.filter.filterCard.channelCode
          })
          break;
      }
    }

    this.svcCard.list(null, null, params).subscribe(items => {
      this.customerItems = items.data
    })
    this.searchPress = true;
  }

  _onCardSelect(data: Card) {
    console.log('card data', data)
    this.onCardSelect.emit(data);
  }

  _onBack() {
    this.onBack.emit();
  }



}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/widget/customer-card-search/customer-card-search.component.ts